import { render } from "./CheckoutSucesso.vue?vue&type=template&id=f286787a"
import script from "./CheckoutSucesso.vue?vue&type=script&lang=js"
export * from "./CheckoutSucesso.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__